import React from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";

import { showDangerAlert } from "../../../../../redux/actions/alert/alertActions";

import ButtonComponent from "../../../button";

import { ActivityButton } from "../../labReport/styledLabReport";

const ActivityButtons = ({
  downloadPdf,
  loading,
  teacherFeedBack,
  openSendActivityModal,
}) => {
  const dispatch = useDispatch();

  const handleDownloadPDF = () => {
    downloadPdf()
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.pdf");
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => {
        dispatch(showDangerAlert("لطفا بعدا دوباره امتحان کنید."));
      });
  };
  return (
    <>
      {teacherFeedBack ? (
        <ButtonComponent
          onClick={openSendActivityModal}
          className="d-block mx-auto col-5 col-md-3 order-2 order-md-1"
        >
          ثبت نمره
        </ButtonComponent>
      ) : (
        <>
          <ButtonComponent
            onClick={handleDownloadPDF}
            className="download-button order-2 order-md-1"
          >
            {loading ? (
              <Spinner
                as="span"
                animation="border"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "دانلود گزارش فعالیت"
            )}
          </ButtonComponent>
          <ActivityButton
            onClick={openSendActivityModal}
            $width="190px"
            className="order-1 order-md-2"
          >
            ارسال گزارش فعالیت
          </ActivityButton>
        </>
      )}
    </>
  );
};

export default ActivityButtons;
